var map = {
	"./App": 1528,
	"./App.vue": 1528,
	"./assets/wallpapers/crystal_canyons.jpg": 7828,
	"./assets/wallpapers/crystal_canyons_alt.jpg": 164,
	"./assets/wallpapers/liquid_quartz.jpg": 7178,
	"./assets/wallpapers/meteor_abyss.jpg": 2235,
	"./assets/wallpapers/polka.jpg": 9853,
	"./assets/wallpapers/refract.jpg": 3165,
	"./assets/wallpapers/rushing_stream.jpg": 9487,
	"./assets/wallpapers/saturated_stream.jpg": 9902,
	"./assets/wallpapers/shimmer.jpg": 4909,
	"./assets/wallpapers/storm.jpg": 9451,
	"./assets/wallpapers/supernova.jpg": 7887,
	"./assets/wallpapers/supersaturation.jpg": 6437,
	"./components/Content": 3078,
	"./components/Content.vue": 3078,
	"./components/Navbar": 5849,
	"./components/Navbar.vue": 5849,
	"./components/Sidebar": 1534,
	"./components/Sidebar.vue": 1534,
	"./components/blog/BlogView": 2022,
	"./components/blog/BlogView.vue": 2022,
	"./components/changelog/ChangelogView": 8254,
	"./components/changelog/ChangelogView.vue": 8254,
	"./components/common/Banner": 8964,
	"./components/common/Banner.vue": 8964,
	"./components/common/Flag": 1051,
	"./components/common/Flag.vue": 1051,
	"./components/common/Loading": 2867,
	"./components/common/Loading.vue": 2867,
	"./components/common/Logo": 132,
	"./components/common/Logo.vue": 132,
	"./components/common/Search": 4905,
	"./components/common/Search.vue": 4905,
	"./components/device/CardBuilds": 7034,
	"./components/device/CardBuilds.vue": 7034,
	"./components/device/CardHeader": 6307,
	"./components/device/CardHeader.vue": 6307,
	"./components/home/Credits": 2935,
	"./components/home/Credits.vue": 2935,
	"./components/home/ProjectLink": 1766,
	"./components/home/ProjectLink.vue": 1766,
	"./components/team/TeamView": 5725,
	"./components/team/TeamView.vue": 5725,
	"./components/wallpapers/Wallpaper": 841,
	"./components/wallpapers/Wallpaper.vue": 841,
	"./components/wallpapers/WallpapersView": 8138,
	"./components/wallpapers/WallpapersView.vue": 8138,
	"./configs": 6571,
	"./configs/": 6571,
	"./configs/index": 6571,
	"./configs/index.js": 6571,
	"./fonts/HarmonyOS_Sans_Bold.ttf": 2510,
	"./fonts/HarmonyOS_Sans_Medium.ttf": 5470,
	"./fonts/HarmonyOS_Sans_Regular.ttf": 2573,
	"./github.svg": 8077,
	"./helpers/request": 76,
	"./helpers/request.js": 76,
	"./helpers/utils": 6231,
	"./helpers/utils.js": 6231,
	"./logo.png": 3409,
	"./logo_dark.svg": 7780,
	"./logo_light.svg": 1260,
	"./main": 4294,
	"./main.js": 4294,
	"./routes": 421,
	"./routes.js": 421,
	"./services/github": 613,
	"./services/github.js": 613,
	"./store/Wallpapers": 1646,
	"./store/Wallpapers.js": 1646,
	"./store/blogStore": 6480,
	"./store/blogStore.js": 6480,
	"./store/deviceStore": 7769,
	"./store/deviceStore.js": 7769,
	"./store/rootStore": 5596,
	"./store/rootStore.js": 5596,
	"./telegram.svg": 5233,
	"./tg.svg": 7480,
	"./twitter.svg": 3029,
	"./views/Blog": 3676,
	"./views/Blog.vue": 3676,
	"./views/Changelog": 6336,
	"./views/Changelog.vue": 6336,
	"./views/Device": 7017,
	"./views/Device.vue": 7017,
	"./views/Home": 1391,
	"./views/Home.vue": 1391,
	"./views/Team": 1112,
	"./views/Team.vue": 1112,
	"./views/Wallpapers": 5222,
	"./views/Wallpapers.vue": 5222
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5538;